
/* injects from baggage-loader */

'use strict';

import { shapes } from './draw-game.const';
import { ShapeConst, ShapeConstTranslate } from '_appRoot/index.const';

import { map, find, findIndex, filter, sample, sampleSize, groupBy, maxBy, minBy } from 'lodash';

export default class DrawGameController {
    constructor($log, $state, $timeout, $Fabric) {
        'ngInject';
        this.$log = $log;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$Fabric = $Fabric;

        this.ShapeConstTranslate = ShapeConstTranslate;

        this.canvas = null;

        this.state = {
            canvas: {
                selected: false,
                enabled: true
            }
        }

        this.answers = {
            a1: {
                value: null,
                error: false
            },
            a2: {
                value: null,
                error: false
            },
            a3: {
                value: null,
                error: false
            },
            a4: {
                value: null,
                error: false
            },
            a5: {
                value: null,
                error: false
            }
        }

        this.shapes = shapes;
        this.shapesInCanvas = [];

        this.colors = Object.values(ShapeConst.colors);
        this.types = Object.values(ShapeConst.types);

        this.listA3Key = sample(['colors', 'types']);
        this.listA3 = ShapeConst[this.listA3Key];

        this.shapesAnswer = {
            a1: sample(this.colors),
            a2: sample(this.types),
            a3: this.getA3Shapes()
        }

        this.step = 1;

        this.localSubtitle = "Arraste as figuras e monte um desenho";
    }

    $onInit() {
        this.title = () => `<span class='level'>Imaginação - Nível ${this.step ? this.step : 1} </span> <br/> ${this.localSubtitle} `;

        this.createCanvas();
    }

    createCanvas() {
        this.canvas = this.$Fabric.create('blue-canvas');

        this.canvas.on('selection:cleared', () => {
            this.state.canvas.selected = false;
        });

        this.canvas.on('selection:created', () => {
            this.state.canvas.selected = true;
        });
    }

    addShape(shape, config) {
        this.$Fabric.addShape(this.canvas, shape, config);
        this.shapesInCanvas.push(shape);
    }

    rotateShape() {
        let angle = 30;
        let $ctrl = this;
        let shape = this.canvas.getActiveObject();
        let resetOrigin = false;

        if (!shape) return;

        let newAngle = shape.angle - angle;

        if ((shape.originX !== 'center' || shape.originY !== 'center') && shape.centeredRotation) {
            $ctrl.setOriginToCenter(shape) && $ctrl.setOriginToCenter(shape);
            resetOrigin = true;
        }

        shape.angle = newAngle;
        shape.setCoords();

        if (resetOrigin) {
            $ctrl.setOriginToCenter(shape) && $ctrl.setOriginToCenter(shape);
        }

        this.canvas.requestRenderAll();
    }

    setOriginToCenter(shape) {
        shape._originalOriginX = shape.originX;
        shape._originalOriginY = shape.originY;

        shape.set({
            originX: 'center',
            originY: 'center',
            left: shape.getCenterPoint().x,
            top: shape.getCenterPoint().y
        })
    }

    setCenterToOrigin(shape) {
        let originPoint = shape.translateToOriginPoint(
            shape.getCenterPoint(),
            shape._originalOriginX,
            shape._originalOriginY);

        shape.set({
            originX: shape._originalOriginX,
            originY: shape._originalOriginY,
            left: originPoint.x,
            top: originPoint.y
        })
    }

    removeShapes() {
        if (!confirm("Você realmente deseja apagar estes objetos?")) return false;

        this.canvas.getActiveObjects().forEach(s => {
            let indexByShape = findIndex(this.shapesInCanvas, { type: s.$type });

            this.shapesInCanvas.splice(indexByShape, 1);

            this.canvas.remove(s)
        });
        // Remove Selection
        this.canvas.discardActiveObject();
        this.canvas.requestRenderAll();
    }

    enableSelection() {
        this.canvas.selection = true;
        this.canvas._objects.forEach(s => s.set({ selectable: true }));
        this.canvas.discardActiveObject();
        this.canvas.requestRenderAll();

        this.state.canvas.enabled = true;
    }

    disableSelection() {
        this.canvas.selection = false;
        this.canvas._objects.forEach(s => s.set({ selectable: false }));
        // Remove Selection
        this.canvas.discardActiveObject();
        this.canvas.requestRenderAll();

        this.state.canvas.enabled = false;
    }

    onDrop(event, data) {
        (this.state.canvas.enabled && this.step === 1) ? this.addShape(data, { left: (event.offsetX - (data.width / 2)), top: (event.offsetY - (data.height / 2)) }): false;
    }

    onDrawerConfirm() {
        this.disableSelection();

        this.shapesAnswer.a4 = this.getA4Shapes();
        this.shapesAnswer.a5 = this.getA5Shapes();

        this.step = 2;
        this.level = this.step;
        this.localSubtitle = 'Responda as perguntas de acordo com o desenho';
    }

    onSubmit() {
        this.answers.a1.error = !this.validationA1();
        this.answers.a2.error = !this.validationA2();
        this.answers.a3.error = !this.validationA3();
        this.answers.a4.error = !this.validationA4();
        this.answers.a5.error = !this.validationA5();

        let errors = [];

        angular.forEach(this.answers, a => errors.push(a.error));

        if (filter(errors, v => v === true).length) return false;

        this.level = 3;

        this.endGame();
    }

    getA3Shapes() {
        return sampleSize(this.listA3, 2);
    }

    getA4Shapes() {
        let colorsGrouped = groupBy(this.shapesInCanvas, "color");

        let colorsGroupedMapped = map(colorsGrouped, function(g) {
            return {
                color: g[0].color,
                total: g.length
            };
        });

        let color1 = maxBy(colorsGroupedMapped, g => g.total);
        let color2 = minBy(colorsGroupedMapped, g => g.total);

        if (color1 !== color2) {
            return [color1, color2];
        } else {
            let newColor = find(colorsGroupedMapped, color => color1 !== color);
            return newColor ? [color1, newColor] : [color1, color2];
        }

    }

    getA5Shapes() {
        let typesGrouped = groupBy(this.shapesInCanvas, "type");

        let typesGroupedMapped = map(typesGrouped, function(g) {
            return {
                type: g[0].type,
                total: g.length
            };
        });

        let type1 = maxBy(typesGroupedMapped, g => g.total);
        let type2 = minBy(typesGroupedMapped, g => g.total);

        if (type1 !== type2) {
            return [type1, type2];
        } else {
            let newShape = find(typesGroupedMapped, type => type !== type1);
            return newShape ? [type1, newShape] : [type1, type2];
        }

    }

    // Validation
    validationA1() {
        let color = filter(this.shapesInCanvas, { color: this.shapesAnswer.a1 }).length;
        return parseInt(this.answers.a1.value) === color;
    }

    validationA2() {
        let type = filter(this.shapesInCanvas, { type: this.shapesAnswer.a2 }).length;
        return parseInt(this.answers.a2.value) === type;
    }

    validationA3() {
        if (this.listA3Key === 'colors') {
            let color1 = filter(this.shapesInCanvas, { color: this.shapesAnswer.a3[0] }).length;
            let color2 = filter(this.shapesInCanvas, { color: this.shapesAnswer.a3[1] }).length;

            // if value is equal Total color1 + color 2
            return parseInt(this.answers.a3.value) === (color1 + color2);
        } else {
            let type1 = filter(this.shapesInCanvas, { type: this.shapesAnswer.a3[0] }).length;
            let type2 = filter(this.shapesInCanvas, { type: this.shapesAnswer.a3[1] }).length;

            // if value is equal Total type 1 + type 2
            return parseInt(this.answers.a3.value) === (type1 + type2);
        }

    }
    validationA4() {
        let color1 = filter(this.shapesInCanvas, { color: this.shapesAnswer.a4[0].color }).length;
        let color2 = filter(this.shapesInCanvas, { color: this.shapesAnswer.a4[1].color }).length;
        let result = (color1 - color2) < 0 ? 0 : (color1 - color2);

        return parseInt(this.answers.a4.value) === result;
    }

    validationA5() {
        let type1 = filter(this.shapesInCanvas, { type: this.shapesAnswer.a5[0].type }).length;
        let type2 = filter(this.shapesInCanvas, { type: this.shapesAnswer.a5[1].type }).length;
        let result = (type1 - type2) < 0 ? 0 : (type1 - type2);

        return parseInt(this.answers.a5.value) === result;
    }

    renderA1ColorText() {
        return this.ShapeConstTranslate.colors.female[this.shapesAnswer.a1 - 1];
    }

    renderA2TypeText() {
        return this.ShapeConstTranslate.types[this.shapesAnswer.a2 - 1];
    }

    renderA3Text() {
        let word1 = (this.shapesAnswer.a3[0] - 1); // Get position translate const
        let word2 = (this.shapesAnswer.a3[1] - 1); // Get position translate const

        return (this.listA3Key === 'colors') ?
            `Quantas figuras ${this.ShapeConstTranslate.colors.female[word1]} e ${this.ShapeConstTranslate.colors.female[word2] }?` :
            `Quantos ${this.ShapeConstTranslate.types[word1]} e ${this.ShapeConstTranslate.types[word2]} você utilizou?`;
    }

    renderA4Text() {
        let word1 = (this.shapesAnswer.a4[0].color - 1); // Get position translate const
        let word2 = (this.shapesAnswer.a4[1].color - 1); // Get position translate const

        return `Quantas figuras ${this.ShapeConstTranslate.colors.female[word1]} você utilizou a mais que ${this.ShapeConstTranslate.colors.female[word2]}?`;
    }

    renderA5Text() {
        let word1 = (this.shapesAnswer.a5[0].type - 1); // Get position translate const
        let word2 = (this.shapesAnswer.a5[1].type - 1); // Get position translate const

        return `Quantos ${this.ShapeConstTranslate.types[word1]} você utilizou a mais que ${this.ShapeConstTranslate.types[word2]}?`;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/draw-game/draw-game.controller.js